__turbopack_context__.v({
  "container": "SQrJdW_container",
  "grid": "SQrJdW_grid",
  "headlineNumber": "SQrJdW_headlineNumber",
});
